import { gql } from 'graphql-request'
import { getVaaGQLClient } from './utils/vaaGQLClient'
import { z } from 'zod'

const cabinDetailsProperty = z.string().nullable()

const cabinDetailsSchema = z.object({
  brandBFF: z.object({
    cabinDetails: z.object({
      legs: z.array(
        z.object({
          dominantCabinName: z.string(),
          checkedBags: cabinDetailsProperty,
          seatPitch: cabinDetailsProperty,
          seatSelection: cabinDetailsProperty,
          carryOnBags: cabinDetailsProperty,
          boardingPriority: cabinDetailsProperty,
          checkInPriority: cabinDetailsProperty,
          loungeAccess: cabinDetailsProperty,
          freshFoods: cabinDetailsProperty,
          beverages: cabinDetailsProperty,
        })
      ),
    }),
  }),
})

type CabinDetailsResponse = z.infer<typeof cabinDetailsSchema>

const cabinDetailsQueryDocument = gql`
  query CabinDetails($request: BrandServiceRequestInput!) {
    brandBFF(request: $request) {
      cabinDetails {
        legs {
          dominantCabinName
          checkedBags
          seatPitch
          seatSelection
          checkedBags
          carryOnBags
          boardingPriority
          checkInPriority
          loungeAccess
          freshFoods
          beverages
        }
      }
    }
  }
`

export async function getCabinDetails(offerId: string, passengerCounts: string) {
  const result = await getVaaGQLClient().request<CabinDetailsResponse>({
    document: cabinDetailsQueryDocument,
    variables: {
      request: {
        offerId,
        passengerCounts,
      },
    },
  })

  return cabinDetailsSchema.parse(result)
}
